import axios from "axios";
import BaseApi from "../BaseApi";
import { ResultNoteTaskType } from "src/Types/Task/ResultNoteTask";
import { TransitionCompleteResponse } from "src/Types/Task";

export default class ResultNoteTaskAPI extends BaseApi {

	static getData = async ( fileId: string, componentId: string ): Promise<ResultNoteTaskType> => {
		const url = `${window.host}/Nvx.ReDoc.Workflow.ResultNoteTask/Task?fileId=${fileId}&componentId=${componentId}`;
		try {
			const request = await axios.get( url , { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при получении данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка при получении данных задачи" );
		}
	};

	/**  */
	static goToTransition = async ( action: string, fileId: string, componentId: string, list: any ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ResultNoteTask/GoToTransition";
		const frmData = new FormData();
		frmData.append( "fileId", fileId );
		frmData.append( "componentId", componentId );
		frmData.append( "action", action );
		frmData.append( "List", JSON.stringify(list) );
		try {
			const request = await axios.post( url , frmData, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error(`Ошибка SimpleTask/GoToTransition !`);
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error(`Ошибка SimpleTask/GoToTransition!`);
		}
	};

	/**  */
	static singleLoadResultNote = async ( fileId: string, componentId: string, list: any ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ResultNoteTask/SingleLoadResultNote";
		const body = { fileId, componentId, list: JSON.stringify(list) , transitionAction: "Submit" };
		try {
			const request = await axios.post( url , body, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка SingleLoadResultNote!");
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка SingleLoadResultNote!");
		}
	}

	/**  */
	static goToSubmitTransition = async ( formData: FormData ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/Nvx.ReDoc.Workflow.ResultNoteTask/GoToSubmitTransition";
		try {
			const request = await axios.post( url , formData, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error(`Ошибка ResultNoteTask/SimpleResultAndGoToTransition !`);
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error(`Ошибка ResultNoteTask/SimpleResultAndGoToTransition!`);
		}
	};

	// static action = async ( action: string, fileId: string, componentId: string, taskId: string ): Promise<TransitionCompleteResponse> => {
	// 	const url = window.host + action;
	// 	const body = { fileId, componentId, taskId };
	// 	try {
	// 		const request = await axios.post( url , body, { withCredentials: true });
	// 		if ( this.checkUnauthorized( request ) ) {
	// 			throw new Error(`Ошибка ${action}!`);
	// 		}
	// 		else {
	// 			return request.data;
	// 		}
	// 	}
	// 	catch (error: any) {
	// 		throw new Error(`Ошибка ${action}!`);
	// 	}
	// };

};
